import { render, staticRenderFns } from "./RolesDrawer.vue?vue&type=template&id=6130b3cf&scoped=true&"
import script from "./RolesDrawer.vue?vue&type=script&lang=js&"
export * from "./RolesDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RolesDrawer.vue?vue&type=style&index=0&id=6130b3cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6130b3cf",
  null
  
)

export default component.exports